
export type SendNotificationRequestRecipient = {
  /** @nullable */
  deviceToken?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  userId?: string | null;
};
